import {MediaButton} from "./MediaButton";

export default MediaButton;